interface TollRecord {
  id: string;
  origin: string;
  destination: string;
  rate: number;
  effectiveDate: string;
  expirationDate?: string;
}

export const mockTollsData: TollRecord[] = [
  {
    id: "toll-1",
    origin: "ATL",
    destination: "ONT",
    rate: 100,
    effectiveDate: "2026-01-01",
    expirationDate: "2026-12-31",
  },
  {
    id: "toll-2",
    origin: "BOS",
    destination: "ATL",
    rate: 100,
    effectiveDate: "2026-01-01",
  },
  {
    id: "toll-3",
    origin: "BOS",
    destination: "ATL",
    rate: 100,
    effectiveDate: "2026-01-01",
    expirationDate: "2026-06-30",
  },
  {
    id: "toll-4",
    origin: "ONT",
    destination: "ATL",
    rate: 100,
    effectiveDate: "2026-01-01",
  },
  {
    id: "toll-5",
    origin: "ONT",
    destination: "ATL",
    rate: 100,
    effectiveDate: "2026-01-01",
  },
  {
    id: "toll-6",
    origin: "ONT",
    destination: "ATL",
    rate: 100,
    effectiveDate: "2026-01-01",
  },
  {
    id: "toll-7",
    origin: "ONT",
    destination: "ATL",
    rate: 100,
    effectiveDate: "2026-01-01",
  },
  {
    id: "toll-8",
    origin: "ONT",
    destination: "ATL",
    rate: 100,
    effectiveDate: "2026-01-01",
  },
  {
    id: "toll-9",
    origin: "ONT",
    destination: "ATL",
    rate: 100,
    effectiveDate: "2026-01-01",
  },
  {
    id: "toll-10",
    origin: "ONT",
    destination: "ATL",
    rate: 100,
    effectiveDate: "2026-01-01",
  },
  {
    id: "toll-11",
    origin: "ONT",
    destination: "ATL",
    rate: 100,
    effectiveDate: "2026-01-01",
  },
];
